module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "part",
    attrs: {
      "id": "p01"
    }
  }, [_c('h1', {
    staticClass: "part"
  }, [_c('a', {
    attrs: {
      "id": "page1"
    }
  }), _c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780062043740_epub_toc_r1.htm#p01a"
    }
  }, [_c('span', {
    staticClass: "underline"
  }, [_vm._v("Part I")])]), _c('br'), _c('img', {
    attrs: {
      "alt": "",
      "src": "OEBPS/images/9780062043740_L02.png"
    }
  }), _c('br'), _c('br'), _c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780062043740_epub_toc_r1.htm#p01a"
    }
  }, [_c('span', {
    staticClass: "big"
  }, [_vm._v("THE PATH INTO THE FOREST")])])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('a', {
    attrs: {
      "id": "page2"
    }
  }), _c('em', [_vm._v("The case histories in this book are true, but the names and"), _c('br'), _vm._v("identifying details have been changed to protect"), _c('br'), _vm._v("the identities of the individuals involved.")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ecdf73f0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/9780062043740_epub_p01_r1.vue
// module id = 75
// module chunks = 0